/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Section,
  SectionListParams,
  Pagination,
  SectionCreationParams
} from '~core/models/core.models';
import { ApiConstantsService } from './api-constants.service';

@Injectable()
export class SectionService {
  protected _httpClient = inject(HttpClient);
  protected _apiConstantsService = inject(ApiConstantsService);

  read(sectionId: string): Observable<Section> {
    return this._httpClient.get<Section>(
      `${this._apiConstantsService.sectionUrl}/${sectionId}`
    );
  }

  list(params?: SectionListParams): Observable<Pagination<Section>> {
    return this._httpClient.get<Pagination<Section>>(
      this._apiConstantsService.sectionUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  create(data: SectionCreationParams): Observable<Section> {
    return this._httpClient.post<Section>(
      this._apiConstantsService.sectionUrl,
      data
    );
  }

  update(
    sectionId: string,
    data: Partial<SectionCreationParams>
  ): Observable<Section> {
    return this._httpClient.patch<Section>(
      `${this._apiConstantsService.sectionUrl}/${sectionId}`,
      data
    );
  }

  delete(sectionId: string): Observable<unknown> {
    return this._httpClient.delete(
      `${this._apiConstantsService.sectionUrl}/${sectionId}`
    );
  }

  reorder(data: Pick<Section, 'id' | 'position'>[]): Observable<unknown> {
    return this._httpClient.post<unknown>(
      `${this._apiConstantsService.sectionUrl}/set`,
      {
        sections: data
      }
    );
  }
}
